import styled from "styled-components";

export const StyledNavItem = styled.div`
  margin-right: 32px;
  cursor: not-allowed; 
`;

export const StyledIconItem = styled.div`
  width: 3%;
  display: flex;
  justify-content: space-around;
`;

export const StyledNav = styled.div`
  color: #4a5368;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  ${StyledIconItem}:last-child {
    margin-right: 24px;
  }
`;

export const StyledNavIcon = styled.div`
  display: flex;
  cursor: not-allowed; 
`;

export const StyledMoreIcon = styled.div`
  margin-right: 58px;
  margin-left: 42px;
  cursor: not-allowed; 
`;
